import React, { Component } from 'react';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import { gql } from '@apollo/client';
import _, { functions } from 'lodash';
import { toast } from 'react-toastify';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import InputHeader from '../../global/inputwithHeader';
import service from '../../../../services/graphQlServices';
import LoadingBar from '../../../components/global/loadingBar';
import Dropzone from 'react-dropzone';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as AttachIcon } from '../../../../assets/svg/attachment.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/arrow-ios-downward.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { ReactComponent as CheckedIcon } from '../../../../assets/svg/check-selected.svg';

import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
import { withRouter } from '../../../../services/withRoute';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var randomize = require('randomatic');

const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;

const getProjects = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;
const getEventsList = gql`
	query Data($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				name
				crew {
					count
					role
					managerIds
					subRole
					userIds
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
			}
		}
	}
`;

const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			displayName
		}
	}
`;
const assignMemoryCard = gql`
	mutation AssignMemoryCard(
		$qrCodes: [String!]!
		$workspaceId: String!
		$assignedTo: LogUserInput!
		$projectId: ID!
		$eventId: ID!
	) {
		assignMemoryCard(
			qrCodes: $qrCodes
			workspaceId: $workspaceId
			assignedTo: $assignedTo
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

class ReAssignMemoryCards extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			showDiscardModal: false,
			isAck: false,

			isFileSrcLoading: false,
			isAPISubmitting: false,
			workspacesFilters: [],
			projectsOptions: [],
			eventNameOptions: [],
			crewOptions: [],

			qrCodes: [],
			workspaceId: '',
			projectID: '',
			shootID: '',
			assignedTo: '',
			assignedToUser: '',
		};
	}

	componentDidMount = async () => {
		await this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});
		this.getTenantUsers(getTenantUserList);
	};

	isDisabled = () => {
		if (
			_.size(this.state.qrCodes) === 0 ||
			this.state.workspaceId === '' ||
			this.state.projectId === '' ||
			this.state.eventId === '' ||
			this.state.assignedToUser === ''
		) {
			return true;
		} else return false;
	};

	DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				<DownIcon />
			</components.DropdownIndicator>
		);
	};

	handleWorkspaceFilters = (e) => {
		this.setState(
			{
				workspaceId: e.value,
				projectID: '',
				shootID: '',
				assignedTo: '',
			},
			async () => {
				this.setState({
					isProjectsLoading: true,
				});
				await this.getVendorProjects(getProjects, {
					workspaceIds: e.value,
					filters: {
						limit: 1000,
						page: 1,
					},
				});
			},
		);
	};

	handleProjectFilters = (e) => {
		this.setState(
			{
				projectId: e.value,
			},
			async () => {
				this.setState({ isEventsListLoading: true });
				let jsonEventsList = {
					filters: {
						page: 1,
						limit: 10000,
						projectId: e.value,
					},
				};

				await this.getEventsNameList(getEventsList, jsonEventsList, true);
			},
		);
	};

	handleShootFilters = (e) => {
		this.setState({
			eventId: e.value,
		});
		let crewOptions = [];
		_.map(_.filter(this.state.events, { id: e.value })[0].crewNew, (crewArray) => {
			if (crewArray.userId !== null && crewArray.isCustomUser !== true) {
				let user = _.filter(this.state.tenantUserList, {
					id: crewArray.userId,
				})[0];

				crewOptions.push({
					label: user.displayName
						? user.displayName
						: user.firstName + ' ' + user.lastName,
					value: user.id,
				});
			}
		});

		this.setState({ crewOptions });
	};

	handleCrewFilters = (e) => {
		this.setState({
			assignedToUser: e.value,
			assignedTo: {
				id: e.value,
				name: e.label,
			},
		});
	};

	handleCloseModal = () => {
		this.setState({ showDiscardModal: true });
	};

	reAssignMemoryCards = async () => {
		let json = {
			qrCodes: this.state.qrCodes,
			assignedTo: this.state.assignedTo,
			eventId: this.state.eventId,
			projectId: this.state.projectId,
			workspaceId: this.state.workspaceId,
		};

		let resp = await this.assignMemoryCard(assignMemoryCard, json);

		if (resp == false) {
			//this.handleCloseModal();
			toast.error('Cannot assign equipment to non verified users!', {
				position: 'top-right',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
		} else {
			toast.success('Memory Cards re-assigned Successfully!', {
				position: 'top-right',
				autoClose: 500,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			this.props.handleClose();
		}
	};

	toggleQrCodes = (qrCode) => {
		let index = _.indexOf(this.state.qrCodes, qrCode);
		let qrCodes = this.state.qrCodes;
		if (index >= 0) {
			_.pull(qrCodes, qrCode);
		} else {
			qrCodes.push(qrCode);
		}
		this.setState({ qrCodes });
	};

	renderMemoryCardsTable = () => {
		return (
			<div className="mc-events-logs-table-container">
				<table>
					<thead>
						<tr>
							<th></th>
							<th>CARD TYPE</th>
							<th>SERIAL NO</th>
							<th>ASSIGNED TO</th>
						</tr>
					</thead>
					<tbody>
						{_.map(
							_.filter(this.props.memoryCardsList, {
								isReceived: false,
							}),
							(mc, index) => {
								return (
									<tr key={`${index}329dufjiodiplk`}>
										<td onClick={() => this.toggleQrCodes(mc.qrCode)}>
											<div className={'reAssignTr'}>
												{_.indexOf(this.state.qrCodes, mc.qrCode) >= 0 ? (
													<span className="check-icon">
														<CheckedIcon />
													</span>
												) : (
													<span className="empty-check"></span>
												)}
											</div>
										</td>
										<td>
											{mc.type ? mc.type.toUpperCase() : ''}{' '}
											{mc.size ? `(${mc.size})GB` : ''}
										</td>
										<td>
											{_.has(mc, 'qrCode')
												? mc.qrCode
													? mc.qrCode.toUpperCase()
													: ''
												: ''}
										</td>
										<td>
											{mc.userId
												? mc.userName
													? mc.userName.toUpperCase()
													: ''
												: ''}
										</td>
									</tr>
								);
							},
						)}
					</tbody>
				</table>
			</div>
		);
	};

	renderFormComponent = () => {
		return (
			<div className="mc-record-body-left-right">
				<div className="attachment-preview-text" style={{ marginBottom: '20px' }}>
					Re-assign to Shoot Details
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Brand
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex5 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.workspacesFilters}
							onChange={(e) => this.handleWorkspaceFilters(e)}
							defaultValue={
								_.has(this.props, 'qrCode')
									? {
											label: this.props.qrCode,
											value: this.props.qrCode,
									  }
									: null
							}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Project
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex4 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.projectsOptions}
							onChange={(e) => this.handleProjectFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isLoading={this.state.isProjectsLoading}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Shoot
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex3 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.eventNameOptions}
							onChange={(e) => this.handleShootFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isLoading={this.state.isEventsListLoading}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Assign To
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex2 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.crewOptions}
							onChange={(e) => this.handleCrewFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							//isLoading={this.state.isHardDriveLoading}
							isSearchable={true}
						/>
					</div>
				</div>
			</div>
		);
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="mc-record-center-modal">
					<div className="mc-record-header">
						<span className="header-title">RE ASSIGN MEMORY CARDS</span>
					</div>
					{this.state.isFileSrcLoading ? (
						<LoadingBar />
					) : (
						<>
							<div className="mc-record-body">
								<div
									className="mc-record-body-left-right"
									style={{
										width: '60%',
										borderRight: '1px solid #272727',
									}}
								>
									<div
										className="attachment-preview-text"
										style={{ marginBottom: '20px' }}
									>
										Select Memory cards to re-assign
									</div>
									<div
										className="attachment-preview-img"
										style={{
											border: '0px solid #b0b0b0',
										}}
									>
										{this.renderMemoryCardsTable()}
									</div>
								</div>
								{this.renderFormComponent()}
							</div>
							<div className="mc-record-tail">
								<div className="button-container">
									<span
										className="cancel-btn"
										onClick={() =>
											this.state.isAPISubmitting === false &&
											this.handleCloseModal()
										}
									>
										Cancel
									</span>
									{this.state.isAPISubmitting === true ? (
										<span className={'confirm-btn active loading-btn'}>
											<LoadingBar />
										</span>
									) : (
										<span
											className={
												'confirm-btn' +
												(this.isDisabled() ? ' ' : ' active')
											}
											onClick={() =>
												this.isDisabled() ? '' : this.reAssignMemoryCards()
											}
										>
											RE-ASSIGN MEMORY CARDS
										</span>
									)}
								</div>
							</div>
						</>
					)}
				</div>
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">DISCARD CHANGES</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you discard this information, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.handleClose();
									this.setState({ showDiscardModal: false });
								}}
							>
								Yes, Discard
							</span>
						</div>
					</div>
				</Modal>
			</Modal>
		);
	}
}

export default withRouter(ReAssignMemoryCards);
